var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33337 8.00008C1.33337 5.48592 1.33337 4.22885 2.11442 3.44779C2.89547 2.66675 4.15255 2.66675 6.66671 2.66675H9.33337C11.8475 2.66675 13.1046 2.66675 13.8856 3.44779C14.6667 4.22885 14.6667 5.48592 14.6667 8.00008C14.6667 10.5142 14.6667 11.7713 13.8856 12.5523C13.1046 13.3334 11.8475 13.3334 9.33337 13.3334H6.66671C4.15255 13.3334 2.89547 13.3334 2.11442 12.5523C1.33337 11.7713 1.33337 10.5142 1.33337 8.00008Z",
    stroke: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.66667 11H4",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.33333 9H4",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.33337 6.66675H14.6667",
    stroke: "#1C274C",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.33337 10.0001C9.33337 9.37155 9.33337 9.05728 9.52864 8.86201C9.72391 8.66675 10.0382 8.66675 10.6667 8.66675C11.2952 8.66675 11.6095 8.66675 11.8048 8.86201C12 9.05728 12 9.37155 12 10.0001C12 10.6286 12 10.9429 11.8048 11.1381C11.6095 11.3334 11.2952 11.3334 10.6667 11.3334C10.0382 11.3334 9.72391 11.3334 9.52864 11.1381C9.33337 10.9429 9.33337 10.6286 9.33337 10.0001Z",
    stroke: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.e9660166256a18826c036e58afb5df43.svg";
export { ForwardRef as ReactComponent };